import { render, staticRenderFns } from "./ModifieClient.vue?vue&type=template&id=315233c6"
import script from "./ModifieClient.vue?vue&type=script&lang=js"
export * from "./ModifieClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports